export type ChartRange = 'day' | 'week' | 'month';

/**
 * Format a UNIX seconds timestamp for the X axis. Format depends on the
 * selected range so axis labels stay readable at every zoom level.
 */
export function formatTick(tsSeconds: number, range: ChartRange): string {
  const d = new Date(tsSeconds * 1000);
  if (range === 'day') {
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  }
  if (range === 'week') {
    return d.toLocaleDateString([], { weekday: 'short', hour: 'numeric' });
  }
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
}
